// src/features/home/Flash_sales/components/FlashSalesSlider.tsx

'use client'; // This is our interactive island

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { FaRegStar, FaStar } from 'react-icons/fa6';
import Link from 'next/link';
import NextImage from '@/features/Image';
import CartButton from './CartButton';

// Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// Define the types for better code quality
interface Product {
  // Add all the properties you use for a product
  slug: string;
  name: string;
  pictures: { url: string }[];
  discount: number;
  ratings: number;
  reviews: number;
  sale_price: number;
  price: number;
}

interface FlashSalesSliderProps {
  products: Product[];
}

export const FlashSalesSlider: React.FC<FlashSalesSliderProps> = ({
  products,
}) => {
  return (
    <div className="product__slider">
      <Swiper
        modules={[Navigation]}
        spaceBetween={12}
        slidesPerView={4}
        breakpoints={{
          320: { slidesPerView: 2 },
          425: { slidesPerView: 2.5, spaceBetween: 16 },
          768: { slidesPerView: 3, spaceBetween: 20 },
          1200: { slidesPerView: 4 },
        }}
        navigation={{
          nextEl: '.product__slider-prev',
          prevEl: '.product__slider-next',
        }}
      >
        {products.map((product) => (
          <SwiperSlide key={product?.slug}>
            <div className="product__item product__item--style1">
              <div className="product__item-inner">
                {product?.discount > 0 && (
                  <div className="product__item-badge">
                    {product?.discount}%
                  </div>
                )}

                {/* {product.badge && (
                          <div className="product__item-badge">
                            {product.badge}
                          </div>
                        )} */}
                <Link
                  href={`/product/${product.slug}`}
                  className="product__item-thumb"
                >
                  <NextImage
                    width={406}
                    height={252}
                    src={product?.pictures?.[0]?.url}
                    alt={product?.name || 'Product Image'}
                    style={{ aspectRatio: '4/3' }}
                  />
                </Link>
                <div className="product__item-content">
                  <h6 className="fw-medium">
                    <Link href={`/product/${product.slug}`}>
                      {product?.name}
                    </Link>
                  </h6>
                  <div className="product__item-rating">
                    <span>
                      {[1, 2, 3, 4, 5].map((star) =>
                        star <= Math.round(product.ratings) ? (
                          <FaStar key={star} />
                        ) : (
                          <FaRegStar key={star} className="text-gray-300" />
                        )
                      )}
                    </span>
                    {/* <span>({data.reviews} Reviews)</span> */}
                    {product?.reviews > 0 && (
                      <span className="fs-small"> ({product?.reviews})</span>
                    )}
                  </div>
                  <div className="product__item-footer">
                    <div className="product__item-price">
                      <h6 className="fw-medium bs-small text-truncate">
                        ৳{Number(product?.sale_price).toFixed(2)}
                        {product?.sale_price !== product?.price && (
                          <>
                            /
                            <span>
                              <del>৳{Number(product?.price).toFixed(2)}</del>
                            </span>
                          </>
                        )}
                      </h6>
                    </div>
                    <div className="product__item-action">
                      <CartButton product={product} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
